import { NavLink, Outlet } from "react-router-dom";
import type { NavSection } from "../../config/navigation";
import { Icon } from "../icons";

export function ModuleHubLayout({
  title,
  subtitle,
  sections,
}: {
  title: string;
  subtitle: string;
  sections: NavSection[];
}) {
  return (
    <div className="flex min-h-0 flex-1 gap-0 overflow-hidden rounded-xl border border-line bg-surface">
      <aside className="flex w-[220px] shrink-0 flex-col border-r border-line bg-surface-2">
        <div className="border-b border-line px-4 py-3">
          <h2 className="text-sm font-semibold text-foreground">{title}</h2>
          <p className="mt-0.5 text-[11px] text-muted">{subtitle}</p>
        </div>
        <nav className="flex min-h-0 flex-1 flex-col gap-1 overflow-y-auto p-2">
          {sections.map((section, sectionIndex) => (
            <div key={section.title ?? sectionIndex}>
              {sectionIndex > 0 && <div className="mx-1 my-2 border-t border-line" />}
              {section.title && (
                <p className="mb-1 px-2.5 text-[10px] font-semibold uppercase tracking-widest text-muted-2">
                  {section.title}
                </p>
              )}
              <div className="flex flex-col gap-0.5">
                {section.items.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end
                    className={({ isActive }) =>
                      `flex items-center gap-2 rounded-lg px-2.5 py-2 text-sm transition-colors ${
                        isActive
                          ? "bg-brand-pink/15 font-medium text-brand-pink"
                          : "text-muted hover:bg-hover hover:text-foreground"
                      }`
                    }
                  >
                    <Icon icon={item.icon} size="sm" className="shrink-0 opacity-80" />
                    <span className="min-w-0 truncate">{item.label}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </nav>
      </aside>
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto p-4 lg:p-6">
        <Outlet />
      </div>
    </div>
  );
}
